import axios from "./request";
import { message } from "antd";

//调用方式
// query().then((res:any) => {

// })
// .catch(err => toast.xxx(error))

// 获取国家数据接口地址
export const getCountry = () => {
  return axios({
    url: "/erp/order/getCountry",
    method: "get"
  });
};

// 获取城市数据接口地址
export const getCity = params => {
  return axios({
    url: "/erp/order/getCityByPid",
    method: "get",
    params
  });
};

// 获取商品分类列表
export const getProductCate = () => {
  return axios({
    url: "/erp/order/getProductCate",
    method: "get"
  });
};

// 获取客服列表
export const getUser = () => {
  return axios({
    url: "/erp/order/getUser",
    method: "get"
  });
};

// 获取地区数据接口地址
export const getArea = () => {
  return axios({
    url: "/getArea",
    method: "get"
  });
};

// 获取订单来源，一级类目的接口地址
export const getPrimaryCategories = () => {
  return axios({
    url: "/getPrimaryCategories",
    method: "get"
  });
};

// 二级类目
export const getSecondCategories = () => {
  return axios({
    url: "/getPrimaryCategories",
    method: "get"
  });
};

// 获取贸易来源数据
export const getTradeSource = () => {
  return axios({
    url: "/getTradeSource",
    method: "get"
  });
};

// 获取贸易状态数据
export const getTradingStatus = () => {
  return axios({
    url: "/getTradingStatus",
    method: "get"
  });
};

// 以下是选择器数据源api
// 获取供应商数据
export const getSupplier = () => {
  return axios({
    url: "/erp/order/getSuppliers",
    method: "get"
  });
};

// 获取订单来源
export const getFromSource = params => {
  return axios({
    url: "/erp/order/getFromSource",
    method: "get",
    params
  });
};

// 获取筛选项数据
export const editItems = params => {
  return axios({
    url: "/erp/order/editItems",
    method: "post",
    params
  });
};

// 编辑筛选项数据
export const getItemsList = () => {
  return axios({
    url: "/erp/order/getItemsList",
    method: "get"
  });
};

// 获取订单列表
// 超时重发 默认：2秒超时 最多发送4次
export const getOrderList = (params, isRetry = false) => {
  if (
    window["getOrderList__retryCount"] &&
    window["getOrderList__retryCount"] >= 0 &&
    !isRetry
  ) {
    window["getOrderList__retryCount"] = 0;
  }
  return axios({
    url: "/erp/order/getOrderList",
    method: "get",
    params,
    timeout: 30000
  })
    .then(resolve => {
      window["getOrderList__retryCount"] = 0;
      return resolve;
    })
    .catch(err => {
      console.log("超时超时");
      var config = err.config;

      // 临时代码
      if (config.retry == 0) {
        message.error("网络错误，请刷新页面");
        return Promise.resolve(
          JSON.stringify({
            //  code: null
          })
        );
      }
      // 临时代码

      // If config does not exist or the retry option is not set, reject
      if (!config || !config.retry) return Promise.reject(err);

      console.log("config.retry", config.retry);

      // Set the variable for keeping track of the retry count
      window["getOrderList__retryCount"] =
        window["getOrderList__retryCount"] || 0;

      // Check if we've maxed out the total number of retries
      if (window["getOrderList__retryCount"] >= config.retry) {
        // Reject with the error
        message.error("网络错误，请刷新页面");
        return Promise.resolve(
          JSON.stringify({
            //  code: null
          })
        );
        //return Promise.reject(err);
      }

      // Increase the retry count
      window["getOrderList__retryCount"] += 1;
      console.log("config.__retryCount", window["getOrderList__retryCount"]);
      // Create new promise to handle exponential backoff
      var backoff = new Promise(function (resolve) {
        setTimeout(function () {
          resolve();
        }, config.retryDelay || 1);
      });

      // Return the promise in which recalls axios to retry the request
      return backoff.then(function () {
        return getOrderList(params, true);
      });
    });
};

// 获取系统菜单列表
export const getSysMenu = () => {
  return axios({
    url: "/erp",
    method: "get"
  });
};

// 批量发货
export const sendGoods = params => {
  return axios({
    url: "/erp/order/sendGood",
    method: "get",
    params
  });
};

// 获取订单状态数据
export const getOrderStatus = () => {
  return axios({
    url: "/erp/order/getOrderStatus",
    method: "get"
  });
};

// 获取订单标签数据
export const getOrderTag = () => {
  return axios({
    url: "/erp/order/getOrderTag",
    method: "get"
  });
};

// 同步淘宝订单
export const importOrder = params => {
  return axios({
    url: "/erp/order/imporTmall",
    method: "post",
    params
  });
};

// 二次确认同意
export const reconfirmOk = params => {
  return axios({
    url: "/erp/order/reconfirmOk",
    method: "post",
    params
  });
};

// 二次确认拒绝
export const reconfirmReject = params => {
  return axios({
    url: "/erp/order/reconfirmReject",
    method: "post",
    params
  });
};

// 批量签名
export const batchSign = params => {
  return axios({
    url: "/erp/order/batchSign",
    method: "post",
    params
  });
};

// 批量二次检查
export const secondCheck = params => {
  return axios({
    url: "/erp/order/secondCheck",
    method: "post",
    params
  });
};

// 批量售后 标异常
export const updateTags = params => {
  return axios({
    url: "/erp/order/updateTags",
    method: "post",
    params
  });
};

// 导出Excel
export const exportOrder = params => {
  return axios({
    url: "/erp/order/exportOrder",
    method: "post",
    params
  });
};

// 分配订单
export const allotOrder = params => {
  return axios({
    url: "/erp/order/allotOrder",
    method: "post",
    params
  });
};

// 获取售后原因
export const getAfterSaleReson = () => {
  return axios({
    url: "/erp/after/getReson",
    method: "get"
  });
};

// 获取售后类型
export const getAfterSaleType = () => {
  return axios({
    url: "/erp/after/getType",
    method: "get"
  });
};

// 创建售后单
export const saveAfterSale = params => {
  return axios({
    url: "/erp/After/saveAfterSale",
    method: "post",
    params
  });
};

// 子订单搜索查询数量
export const getOrderListSum = params => {
  return axios({
    url: "/erp/order/getOrderListSum",
    method: "post",
    params
  });
};

// 消息管理开始
// 获取消息列表
export const getNoticeList = params => {
  return axios({
    url: "/erp/msg/index",
    method: "get",
    params
  });
};

// 拉取客服群组
export const getUserList = () => {
  return axios({
    url: "/erp/msg/user",
    method: "get"
  });
};

// 标记已读
export const tagRead = params => {
  return axios({
    url: "/erp/msg/tagread",
    method: "get",
    params
  });
};

// 标记收藏
export const tagCollect = params => {
  return axios({
    url: "/erp/msg/tagcollec",
    method: "get",
    params
  });
};

// 获取七牛配置信息 token, domain
export const getQNConfig = () => {
  return axios({
    url: "/erp/msg/getToken",
    method: "get"
  });
};

// 发送消息
export const sendNotice = params => {
  return axios({
    url: "/send",
    method: "post",
    params
  });
};

// 未读数据统计
export const unReadCount = params => {
  return axios({
    url: "/erp/msg/readcount",
    method: "get",
    params
  });
};

// 消息结束

// 获取用户信息
export const getUserInfo = () => {
  return axios({
    url: "/erp/user/index",
    method: "get"
  });
};

// 退出登录
export const logout = () => {
  return axios({
    url: "/erp/user/logout",
    method: "post"
  });
};

// 获取订单详情
export const getOrderDetails = params => {
  return axios({
    url: "/erp/orderdetails",
    method: "get",
    params
  });
};

// 查询酒店酒店
export const getHotel = params => {
  return axios({
    url: "/erp/hotel/search",
    method: "get",
    params
  });
};

// 获取常用出行人
export const getTraveler = params => {
  return axios({
    url: "/erp/Traveler/index",
    method: "get",
    params
  });
};

// 获取常用出行人
export const getHotelList = params => {
  return axios({
    url: "/erp/hotel/index",
    method: "get",
    params
  });
};

// 提交信息
export const submit = params => {
  return axios({
    url: "/erp/orderdetails/submit",
    method: "post",
    params
  });
};

// 查看付款详情
export const paymentlist = params => {
  return axios({
    url: "/erp/orderdetails/paymentlist",
    method: "get",
    params
  });
};

// 查看可合并列表
export const mergelist = params => {
  return axios({
    url: "/erp/orderdetails/mergelist",
    method: "get",
    params
  });
};

// 查看日志
export const aliLog = params => {
  return axios({
    url: "/erp/Order/aliLog",
    method: "get",
    params
  });
};

// 查看备注列表
export const remarklist = params => {
  return axios({
    url: "/erp/Orderdetails/remarklist",
    method: "get",
    params
  });
};

// 新增备忘录
export const remark = params => {
  return axios({
    url: "/erp/Orderdetails/remark",
    method: "post",
    params
  });
};

// 售后
export const afterList = params => {
  return axios({
    url: "/erp/Orderdetails/afterList",
    method: "get",
    params
  });
};

// 退款列表
export const refundList = params => {
  return axios({
    url: "/erp/Orderdetails/refundList",
    method: "get",
    params
  });
};

// 邮件列表
export const emailList = params => {
  return axios({
    url: "/erp/Orderdetails/emailList",
    method: "get",
    params
  });
};

// 订单日志
export const logList = params => {
  return axios({
    url: "/erp/Orderdetails/logList",
    method: "get",
    params
  });
};

// 用户列表
export const userList = params => {
  return axios({
    url: "/erp/Orderdetails/userList",
    method: "get",
    params
  });
};

// 成本列表
export const costList = params => {
  return axios({
    url: "/erp/Orderdetails/costList",
    method: "get",
    params
  });
};

// 成本改变
export const changeCost = params => {
  return axios({
    url: "/erp/Orderdetails/changeCost",
    method: "post",
    params
  });
};

// 微信行中消息
export const wechatList = params => {
  return axios({
    url: "/erp/Orderdetails/wechatList",
    method: "get",
    params
  });
};

// 微信行中消息
export const dispatchList = params => {
  return axios({
    url: "/erp/Orderdetails/dispatchList",
    method: "get",
    params
  });
};

// 微信行中消息
export const downloadjpg = params => {
  return axios({
    url: "/erp/Orderdetails/downloadjpg",
    method: "get",
    params
  });
};

// 创建补差
export const createLink = params => {
  return axios({
    url: "/erp/Orderdetails/createLink",
    method: "post",
    params
  });
};


export const sendWechatTemplate = params => {
  return axios({
    url: "/erp/Orderdetails/sendWechatTemplate",
    method: "post",
    params
  });
};

export const refundFee = params => {
  return axios({
    url: "/erp/Orderdetails/refundFee",
    method: "post",
    params
  });
};

export const sendMail = params => {
  return axios({
    url: "/erp/Orderdetails/sendMail",
    method: "post",
    params
  });
};

export const sendSMS = params => {
  return axios({
    url: "/erp/Orderdetails/sendSMS",
    method: "post",
    params
  });
};

export const autoMail = params => {
  return axios({
    url: "/erp/Orderdetails/autoMail",
    method: "post",
    params
  });
};

export const addOrder = params => {
  return axios({
    url: "/erp/Orderdetails/addOrder",
    method: "post",
    params
  });
};

export const add = params => {
  return axios({
    url: "/erp/Hotel/add",
    method: "post",
    params
  });
};

export const saveSupplier = params => {
  return axios({
    url: "/erp/Orderdetails/saveSupplier",
    method: "post",
    params
  });
};

export const afterRefund = params => {
  return axios({
    url: "/erp/Orderdetails/afterRefund",
    method: "post",
    params
  });
};

export const getSkuUnit = params => {
  return axios({
    url: "/erp/Orderdetails/getSkuUnit",
    method: "get",
    params
  });
};

export const getCustomMaster = params => {
  return axios({
    url: "/erp/order/getUser",
    method: "get",
    params
  });
}

export const getCustomOrderList = params => {
  return axios({
    url: "/erp/custom/index",
    method: "get",
    params
  });
}

export const delCustomOrderById = params => {
  return axios({
    url: "erp/custom/del",
    method: "get",
    params
  });
}

export const getCustomSum = params => {
  return axios({
    url: "/erp/custom/getCustomSum",
    method: "get",
    params
  });
}

export const exportCustomOrder = params => {
  return axios({
    url: "/erp/custom/export",
    method: "get",
    params
  });
}


export const getCustomCost = params => {
  return axios({
    url: "/erp/custom/getCost",
    method: "get",
    params
  });
}

export const getCustom = params => {
  return axios({
    url: "/erp/custom/getCustom",
    method: "get",
    params
  });
}

export const getSkuMoney = params => {
  return axios({
    url: "/erp/custom/getMoney",
    method: "get",
    params
  });
}

export const delCustomOrder = params => {
  return axios({
    url: "/erp/custom/cancel",
    method: "get",
    params
  });
}

export const saveCustomOrder = params => {
  return axios({
    url: "/erp/custom/submit?type=save",
    method: "post",
    params
  });
}

export const submitCustomOrder = params => {
  return axios({
    url: "/erp/custom/submit",
    method: "post",
    params
  });
}



export const getMoneyCode = params => {
  return axios({
    url: "/erp/Orderdetails/getMoneyCode",
    method: "get",
    params
  });
};

export const unsubscribe = params => {
  return axios({
    url: "/erp/Orderdetails/unsubscribe",
    method: "post",
    params
  });
};

export const nounsubscribe = params => {
  return axios({
    url: "/erp/Orderdetails/nounsubscribe",
    method: "post",
    params
  });
};

export const verify = params => {
  return axios({
    url: "/erp/Orderdetails/verify",
    method: "post",
    params
  });
};

export const submitTag = params => {
  return axios({
    url: "/erp/Orderdetails/submitTag",
    method: "post",
    params
  });
};

export const check = params => {
  return axios({
    url: "/erp/Hotel/check",
    method: "post",
    params
  });
};

export const getStatistics = params => {
  return axios({
    url: "/erp/index/home",
    method: "get",
    params,
    isShowError: false
  })
}